module.exports = __webpack_public_path__ + "img/phone-modele-frame.2b8b382a.png";